/**
 * File: RedirectKeepingSearch.tsx
 * Path: apps/admin/src/modules/layout/components/RedirectKeepingSearch.tsx
 * Description: Sends an old address to its new page with the same ?query,
 * so links that still carry ?leadId= or ?clientId= keep their record.
 */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export const RedirectKeepingSearch: React.FC<{ to: string }> = ({ to }) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
};
